import React, { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import './errorPage.scss';
import '../../apis/base';
import { withCustomTranslation } from '@/hooks/useCustomTranslation';
import { keycodeHandle } from '../../util/util';

const ErrorPage = ({ t, history }) => {
  const [countdown, setCountdown] = useState(5);

  const backToHome = useCallback((e) => {
    e?.preventDefault?.();
    history.push('/');
  }, [history]);

  useEffect(() => {
    keycodeHandle({
      exit: backToHome,
      quit: backToHome,
      click: backToHome,
    });
    // 倒计时逻辑
    const timer = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timer);
          backToHome();
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    // 清理函数
    return () => {
      keycodeHandle({});
      clearInterval(timer);
    };
  }, [backToHome]);

  return (
    <div className="error-page">
      <div className="error-page__image" />
      <div className="error-page__message">
        {t('没有相关内容，请选择其他')}
      </div>
      <div className="error-page__button-wrapper">
        <button
          className="error-page__button"
          onClick={backToHome}
        >
          {t('返回首页')}{`(${countdown}s)`}
        </button>
      </div>
    </div>
  );
};

export default withRouter(withCustomTranslation(ErrorPage));
